import { Injectable } from '@angular/core';
import { delay, of } from 'rxjs';

import type { FiltersClient } from '../../../core/tokens/filters-client.token';
import type { IFilterResponse } from '../../../shared/components/filter-bar/models/filter.model';
import { DEFAULT_SERVICE_DEPARTMENTS } from '../constants/service-departments.constants';

@Injectable({ providedIn: 'root' })
export class FiltersMockService implements FiltersClient {
  getFilters(_organizationId: string) {
    return of({
      medication: [
        {
          key: 'Acetaminophen-Codeine Tab',
          label: 'Acetaminophen-Codeine Tab',
          value: '6b52a515-75b6-4601-92fc-cd1bf57a7900',
        },
        {
          key: 'Ibuprofen 400mg Tab',
          label: 'Ibuprofen 400mg Tab',
          value: '17e71da5-66bb-466f-adbc-752a68cf0b30',
        },
        {
          key: 'Morphine Sulfate Inj',
          label: 'Morphine Sulfate Inj',
          value: '3a4c82e1-91d2-48b3-b6a7-f2dc1e9a45c8',
        },
      ],
      location: [
        {
          key: 'Anes Proc',
          label: 'Anes Proc',
          value: '11f0d013-07a4-4ecc-9873-791d5b08a3b4',
          children: [
            {
              key: 'ANESTHESIA IP UH',
              label: 'ANESTHESIA IP UH',
              value: '90ca551c-4208-414c-ab6a-a2ce5b9601cd',
            },
          ],
        },
        {
          key: 'ICU',
          label: 'ICU',
          value: '6d8e3870-5aae-4fd5-afce-03d7daf417d6',
          children: [
            {
              key: 'ICU - West Wing',
              label: 'ICU - West Wing',
              value: '349721b9-a0f0-4e50-a143-ad1dcc34d0ee',
            },
            {
              key: 'ICU - East Wing',
              label: 'ICU - East Wing',
              value: '349721b9-a0f0-4e50-a143-ad1dcc34d0aa',
            },
          ],
        },
      ],
      serviceDepartment: DEFAULT_SERVICE_DEPARTMENTS,
    } satisfies IFilterResponse).pipe(delay(300));
  }
}
